import { WebStorage, WebStorageNames } from "../../../utils";

/** @returns {number | null} */
export const getPayrollRoleId = () => {
  const r = WebStorage.getLocalStore(WebStorageNames.RoleId) ?? localStorage.getItem("roleId");
  const n = parseInt(String(r), 10);
  return Number.isFinite(n) ? n : null;
};

/** Company admin and super admin — same pattern as timesheet reports / attendance admin areas */
export const isPayrollAdmin = (roleId) => roleId === 1 || roleId === 2;
